export default {
  common: {
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    phoneNumber: 'رقم الهاتف',
    countrySelect: 'اختر الدولة',
    countryUnmodifiedNote: 'لا يمكن تعديل الدولة بعد التسجيل',
    next: 'التالي',
    back: 'رجوع',
    attention: 'انتبه',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    modify: 'تعديل',
    ignore: 'تجاهل',
    firstName: 'الاسم الأول',
    middleName: 'الاسم الأوسط',
    lastName: 'الاسم الأخير',
    gender: 'الجنس',
    male: 'ذكر',
    female: 'أنثى',
    birthday: 'عيد الميلاد',
    graphicCode: 'الرمز البياني',
    emailCode: 'رمز التحقق من البريد الإلكتروني',
    smsCode: 'رمز الرسائل القصيرة',
    smsVerificationCode: 'رمز التحقق من الرسائل القصيرة',
    bind: 'ربط',
    send: 'إرسال',
    resend: 'إعادة الإرسال',
    address: 'العنوان',
    done: 'تم',
    systemMessage: 'رسالة النظام',
    setting: 'الإعداد',
    submit: 'إرسال',
    language: 'اللغة',
    edit: 'تعديل',
    delete: 'حذف'
  },
  account: {
    account: 'الحساب',
    nickname: 'الاسم المستعار',
    id: 'المعرف',
    basicInfo: 'المستوى الأساسي',
    placeholder: 'يرجى إدخال',
    completed: 'مكتمل',
    semiInfo: 'شبه محقق',
    fullyInfo: 'محقق بالكامل',
    basicTab: 'أساسي',
    advancedTab: 'متقدم',
    linkedAccount: 'حساب السحب المرتبط',
    accountSecurity: 'حساب MetWallet والأمان',
    logout: 'تسجيل الخروج',
    semiToast: 'يرجى إكمال التحقق من المستوى الأساسي',
    fullyToast: 'يرجى إكمال المستوى الأساسي \n والتحقق شبه المتحقق',
    quickLoginTitle: 'تسجيل الدخول السريع',
    cancelQuickLogin: 'هل أنت متأكد من تعطيل تسجيل الدخول السريع؟'
  },
  accountSecurity: {
    title: 'الحساب والأمان',
    payPwd: 'كلمة مرور الدفع',
    loginPwd: 'كلمة مرور تسجيل الدخول',
    changeEmail: 'تغيير البريد الإلكتروني',
    changePhone: 'تغيير رقم الهاتف',
    changePayPwd: 'تغيير كلمة مرور الدفع',
    changeLoginPwd: 'تغيير كلمة مرور تسجيل الدخول',
    bindEmail: 'ربط البريد الإلكتروني',
    bindEmailNote: 'قم بتمرير التحقق من البريد الإلكتروني لربطه',
    bindEmailPlaceholder: 'أدخل البريد الإلكتروني الذي تريد ربطه',
    smsBindNote: 'اجتز عملية التحقق من الرسائل القصيرة لربطها',
    bindPhone: 'ربط رقم الهاتف',
    smsAuthentication: 'مصادقة الرسائل القصيرة',
    emailAuthentication: 'مصادقة البريد الإلكتروني',
    phoneVerificationNote: 'اجتز التحقق من رقم الهاتف الحالي أولاً',
    bindPhonePlaceholder: 'أدخل رقم الهاتف الذي تريد ربطه',
    verificationWrongToast: 'يرجى التحقق من رمز التحقق الخاص بك',
    phoneNumberEmptyToast: 'يرجى ملء رقم الهاتف',
    verificationCodeEmptyToast: 'يرجى ملء الرمز',
    wrongCodeToast: 'رمز خاطئ',
    changeNote: 'يرجى اجتياز عملية التحقق لتغييره.',
    newEmailVerification: 'التحقق من البريد الإلكتروني الجديد',
    newEmailPlaceholder: 'أدخل بريدك الإلكتروني الجديد',
    change: 'تغيير',
    emailLowercaseToast: 'يجب أن يكون البريد الإلكتروني بأحرف صغيرة.',
    newEmailEmptyToast: 'يرجى إدخال البريد الإلكتروني الجديد',
    changeSuccessToast: 'تم التغيير بنجاح',
    phonePlaceholder: 'أدخل الهاتف',
    currentEmail: 'البريد الإلكتروني الحالي',
    passCurrentEmailVerificationFirst: 'اجتاز التحقق من البريد الإلكتروني الحالي أولاً',
    currentEmailVerification: 'التحقق من البريد الإلكتروني الحالي',
    smsVerification: 'التحقق من الرسائل القصيرة',
    currentPhoneNumber: 'رقم الهاتف الحالي',
    currentPhoneVerification: 'التحقق من الهاتف الحالي',
    currentEmailAddress: 'عنوان البريد الإلكتروني الحالي',
    phoneVerification: 'التحقق من الهاتف',
    enterVerificationCode: 'أدخل رمز التحقق',
    newPhoneNumber: 'رقم هاتف جديد',
    newEmail: 'بريد إلكتروني جديد'
  },
  withdrawAccount: {
    selectAccountType: 'حدد نوع الحساب',
    noBasicLevelVerificationDialog: 'يرجى إكمال التحقق من المستوى الأساسي قبل ربط طريقة السحب النقدي.',
    bindNote: 'يرجى ملء معلومات الحساب الصحيحة، وإلا سيتأثر سحبك.',
    bindBankAccount: 'ربط حساب مصرفي',
    bindMobileMoneyAccount: 'ربط حساب Mobile Money',
    fieldEmptyToast: '{0} مطلوب',
    fieldLengthToast: 'يجب أن يحتوي {0} على {1} حرف على الأقل',
    bindBankRepeatToast: 'لا تربط نفس الحساب المصرفي بشكل متكرر!',
    accountName: 'اسم الحساب',
    ifscCode: 'رمز IFSC',
    accountEmptyToast: 'مطلوب الحساب',
    accountNameEmptyToast: 'مطلوب اسم الحساب',
    phoneEmptyToast: 'مطلوب الهاتف',
    emailEmptyToast: 'مطلوب البريد الإلكتروني',
    ifscCodeEmptyToast: 'مطلوب رمز IFSC',
    ifscCodeLengthToast: 'يجب أن يكون رمز IFSC مكونًا من 11 رقمًا',
    bindIMPSRepeatToast: 'لا تربط نفس حساب IMPS بشكل متكرر!',
    bindNote2: 'يرجى ملء عنوان TRC-20 الصحيح. سيؤدي العنوان الخاطئ إلى فقدان الدفع، ولا نتحمل أي مسؤولية.',
    usdtAddress: 'عنوان USDT (TRC-20):',
    minimumLimit: 'الحد الأدنى للسحب لكل معاملة: 10 دولارات',
    usdtFee: 'الرسم: تخضع للرسوم الفعلية',
    registerGcash: 'إذا لم يكن لديك حساب Gcash، فيرجى النقر هنا للتسجيل.',
    registerEpay: 'إذا لم يكن لديك حساب Epay، فيرجى النقر هنا للتسجيل.',
    bindThirdPartyTitle: 'ربط حساب {0}',
    wrongAccountToast: 'حساب خاطئ',
    accountFormatToast: 'تنسيق الحساب غير صحيح',
    bindThirdPartyFailedToast: 'فشل ربط {0}',
    queryFailedToast: 'فشل الاستعلام.',
    editFailedToast: 'فشل التحرير.',
    add: 'إضافة',
    confirmEditDialog: 'هل أنت متأكد من تحرير الحساب {0}؟',
    payPwdRequireDialog: 'يرجى تعيين كلمة مرور للدفع مكونة من 6 أرقام قبل إضافة حساب.',
    unbindFailedToast: 'فشل إلغاء الربط',
    cashOutSuccessNote: 'وقت الوصول المقدر: في غضون 7 أيام عمل',
    requestSubmitted: 'تم تقديم طلب السحب',
    amountLimitToast1: 'يجب أن يكون مبلغ السحب ≥40.00 دولار',
    amountLimitToast2: 'يجب أن يكون مبلغ السحب ≥{0}.00 دولار',
    // eslint-disable-next-line no-template-curly-in-string
    recommendAmountNote: 'نصائح: تجميع المبلغ إلى ${0} قبل السحب سيوفر لك رسوم المعالجة بشكل فعال.',
    amountNotEnoughToast: 'مبلغ السحب غير كافٍ',
    exceedingLimitToast1: 'مبلغ السحب اليوم وصل إلى الحد الأقصى',
    exceedingLimitToast2: 'مبلغ السحب اليوم وصل إلى الحد الأقصى. هل تحتاج إلى إكمال الشهادة المتقدمة لرفع الحد؟',
    restrictedCountriesPayPalAccountToast:
      'لا تستخدم حساب PayPal في البلدان المقيدة، مما سيؤدي إلى حظر Arripay الخاص بك',
    withdrawMinimumToast: 'الحد الأدنى للسحب لكل معاملة: 40 دولارًا',
    bankNotAvailableToast: 'هذا البنك لم يعد متاحًا، يرجى ربط البنوك الأخرى.',
    usdtAccountInvalidToast: 'لا يمكن سحب هذا الحساب USDT، يرجى استخدام حساب جديد للسحب.',
    noPayPwdToast: 'يرجى تعيين كلمة مرور للدفع مكونة من 6 أرقام قبل السحب.',
    editBankAccount: 'تعديل حساب البنك',
    accountPlaceholder: 'أدخل حسابك',
    trc20Placeholder: 'أدخل عنوان TRC-20',
    accountRepeatToast: 'نفس كلمة المرور الحالية.',
    unbindBankCardConfirmDialog: 'هل أنت متأكد من إلغاء ربط بطاقة البنك {0}؟',
    unbindMobileMoneyAccountConfirmDialog: 'هل أنت متأكد من إلغاء ربط حساب الأموال عبر الهاتف المحمول {0}؟',
    unbindAccountConfirmDialog: 'هل أنت متأكد من إلغاء ربط الحساب {0}؟',
    availableBalance: 'الرصيد المتاح {0}',
    estimatedFee: 'الرسوم المقدرة',
    submitFailToast: 'فشل الإرسال',
    disabledMethodToast: 'هذه القناة غير متاحة مؤقتًا',
    channelUnavailableTitle: 'القناة غير متاحة',
    channelUnavailableNote: 'قناة السحب هذه غير متاحة مؤقتًا. يرجى تجربة طريقة أخرى.',
    channelUnavailableOk: 'حسنًا',
    bankTransferUnavailableTitle: 'التحويل البنكي غير متاح',
    bankTransferUnavailableNote: 'التحويل البنكي غير متاح لحسابك حالياً. يرجى استخدام Epay للسحب.',
    channelMaintenanceTitle: 'القناة قيد الصيانة',
    channelMaintenanceNote: 'قناة السحب هذه قيد الصيانة. يرجى تجربة طريقة أخرى.',
    bankInfoUpdateTitle: 'حدّث معلوماتك البنكية',
    bankInfoUpdateNote: 'بسبب تعديل سياسة البنك، يرجى تحديث بياناتك البنكية للمتابعة.',
    bindEpay: 'ربط Epay',
    useEpay: 'استخدام Epay',
    iMPSMaxLimitToast: 'الحد الأقصى لمبلغ السحب لمعاملة واحدة من خلال هذه القناة هو 260 دولارًا',
    linkedAccount: 'تمت إضافة الحساب',
    otherAccounts: 'يمكن إضافة حسابات أخرى',
    withdrawTo: 'التحويل إلى',
    withdrawAmount: 'مبلغ التحويل',
    withdrawable: 'قابل للسحب',
    documentIdToast: 'يمكن أن يحتوي رقم الهوية على أرقام فقط',
    noAvailableMethodNote: 'لا توجد طريقة سحب متاحة',
    recommended: 'موصى به'
  },
  paymentCode: {
    changePayPwd: 'تغيير كلمة مرور الدفع',
    setPayPwd: 'تعيين كلمة مرور الدفع',
    setPayPwdNote: 'يرجى تعيين كلمة مرور للدفع مكونة من 6 أرقام',
    reenterPayPwdNote: 'أدخل مرة أخرى',
    verificationNote: 'يرجى اجتياز التحقق لتعيينها.',
    emailVerification: 'التحقق من البريد الإلكتروني',
    inconsistentPasswordToast: 'كلمة مرور غير متسقة',
    payPwdNote: 'يرجى إدخال كلمة مرور الدفع',
    payPwdFormatToast: 'كلمة مرور الدفع مكونة من 6 أرقام',
    payPwdWrongToast: 'كلمة مرور دفع خاطئة',
    payPwdVerificationFailToast: 'فشل التحقق من كلمة مرور الدفع!',
    successToast: 'تم التعيين بنجاح'
  },
  authorize: {
    requirement:
      '{0} يحتاج إلى الحصول على المعلومات التالية من MetWallet{1} الخاص بك لتقديم الخدمة ذات الصلة لك. الاسم المستعار، الصورة الرمزية، الجنس، إلخ.',
    authorize: 'التفويض',
    switchAccount: 'تبديل الحساب',
    goToMetWallet: 'الانتقال إلى MetWallet',
    notMatchTips: 'فشلت العملية. يمكنك فقط تمكين تسجيل الدخول السريع باستخدام حساب MetWallet المرتبط بك'
  },
  basicLevel: {
    namePlaceholder: 'لا توجد رموز أو أرقام',
    verification: 'التحقق',
    whatsAvailable: 'ما هو متاح',
    cashOut: 'السحب النقدي',
    withdrawLimit: '50 دولارًا في اليوم',
    basicLevelNote: 'يرجى إدخال معلوماتك الشخصية الحقيقية. المعلومات الخاطئة قد تتسبب في فشل السحب.',
    fieldEmptyToast: 'يرجى ملء جميع الحقول المطلوبة.',
    successToast: 'تم الحفظ بنجاح',
    failToast: 'فشل الحفظ',
    confirmDialog: 'تأكد من إدخال معلوماتك الشخصية الحقيقية. المعلومات الخاطئة قد تتسبب في فشل السحب.',
    birthdayFormatToast: 'تنسيق حقل عيد الميلاد غير صحيح',
    verificationCodeError: 'خطأ في رمز التحقق',
    verificationCodeEmpty: 'رمز التحقق فارغ',
    noEmailCodeToast: 'يرجى الحصول على رمز التحقق من البريد الإلكتروني',
    checkDialogTitle: 'تحقق من معلوماتك',
    checkDialogContent: 'للسحب بنجاح، يرجى التحقق من معلوماتك. المعلومات الخاطئة قد تتسبب في فشل السحب.',
    check: 'فحص'
  },
  semiVerified: {
    uploadPhotoId: 'تحميل بطاقة هوية مصورة',
    photoId: 'بطاقة هوية مصورة',
    resubmit: 'إعادة الإرسال',
    limit: '5000 دولار أمريكي في اليوم',
    uploading: 'جاري التحميل...',
    notUploadProofToast: 'يرجى تحميل إثبات بطاقة الهوية'
  },
  fullyVerified: {
    frontOfId: 'وجه الهوية',
    backOfId: 'ظهر الهوية',
    uploadIdFront: 'تحميل وجه الهوية',
    uploadIdBack: 'تحميل ظهر الهوية',
    withdrawDailyHint: 'املأ المعلومات للسحب > {0} في اليوم.',
    notUploadIdToast: 'يرجى تحميل وجه وظهر الهوية',
    proofTitle: 'وثيقة إثبات الإقامة',
    acceptableProof: 'إن إثبات الإقامة المقبول هو:',
    acceptableProof1: 'كشف حساب مصرفي.',
    acceptableProof2: 'فاتورة خدمات (كهرباء، مياه، إنترنت، الخ).',
    acceptableProof3: 'وثيقة صادرة عن الحكومة (بيان ضريبي، شهادة إقامة، وما إلى ذلك).',
    unacceptableProof: 'لا يمكننا قبول العنوان الموجود في وثيقة الهوية التي قدمتها كدليل صالح على الإقامة.',
    limit: '10000 دولار أمريكي في اليوم',
    notUploadToast: 'يرجى تحميل وثيقة إثبات الإقامة',
    incorrectFormatToast: 'يرجى تحميل صورة بتنسيق jpg/png/jpeg.'
  },
  loginAndRegister: {
    pwd: 'كلمة المرور',
    lastLogin: 'آخر تسجيل دخول',
    moreOptions: 'خيارات أخرى',
    agreeCheckboxContent: 'الموافقة على {0} و{1}',
    userAgreement: 'اتفاقية المستخدم',
    privacyPolicy: 'سياسة الخصوصية',
    notAgreeToast: 'الموافقة على اتفاقية المستخدم وسياسة الخصوصية',
    forgotPassword: 'نسيت كلمة المرور',
    linkedMail: 'البريد الإلكتروني المرتبط',
    verificationCode: 'رمز التحقق',
    newPwd: 'كلمة مرور جديدة',
    repeatPwd: 'تكرار كلمة المرور',
    confirmPwd: 'تأكيد كلمة المرور',
    noLinkedEmailToast: 'لا يوجد بريد إلكتروني مرتبط بحسابك',
    unregisteredToast: 'لم يتم تسجيل هذا الرقم',
    pwdFormatToast: 'تنسيق كلمة المرور خاطئ',
    resetSuccessToast: 'إعادة التعيين بنجاح',
    pwdNotMatchToast: 'لا تتطابق كلمات المرور مرتين',
    emailFormatToast: 'تنسيق البريد الإلكتروني خاطئ',
    phoneNumberFormatToast: 'تنسيق رقم الهاتف خاطئ',
    invalidAreaCodeToast: 'رمز المنطقة غير صالح',
    login: 'تسجيل الدخول',
    pwdLogin: 'تسجيل الدخول عبر كلمة المرور',
    emailCodeLogin: 'تسجيل الدخول عبر رمز التحقق من البريد الإلكتروني',
    smsLogin: 'تسجيل الدخول عبر الرسائل القصيرة',
    verifyEmail: 'التحقق من البريد الإلكتروني',
    verifyPhone: 'التحقق من الهاتف',
    accountDangerDialog:
      'تم اكتشاف حسابك بأنه معرض للخطر. يرجى إعادة التحقق من حسابك، وإلا فلن تتمكن من الاستمرار في استخدام حسابك.',
    sendEmailCodeDialog: 'لقد أرسلنا رمز التحقق إلى بريدك الإلكتروني {0}. يرجى إدخال رمز التحقق.',
    sendSmsCodeDialog: 'لقد أرسلنا رمز التحقق إلى هاتفك {0}. يرجى إدخال رمز التحقق.',
    graphicCodeEmptyToast: 'يرجى إدخال الرمز الرسومي.',
    countryUnselectToast: 'يرجى اختيار بلدك أولاً',
    unsupportedLoginTypeToast: 'نوع تسجيل دخول غير مدعوم',
    pwdWrongLimitOverDialog:
      'تم إدخال كلمة مرور خاطئة 3 مرات. يرجى استخدام رمز التحقق من الرسائل القصيرة لتسجيل الدخول.',
    loginFailedToast: 'فشل تسجيل الدخول',
    signIn: 'تسجيل الدخول',
    pwdPlaceholder: 'أدخل كلمة المرور',
    pwdNote: 'أدخل 8-16 حرفًا تشمل حروفًا وأرقامًا',
    reenterPwdPlaceholder: 'أعد إدخال كلمة المرور',
    reenterPwdNote: 'يرجى إعادة إدخال كلمة المرور',
    createAccount: 'إنشاء حساب',
    chooseCountryNote: 'يرجى اختيار الدولة',
    pwdInconsistentToast: 'ليست هي نفسها كلمة المرور السابقة التي أدخلتها',
    createSuccessToast: 'إنشاء \n بنجاح',
    registerFailToast: 'فشل التسجيل',
    userNotExistToast: 'المستخدم غير موجود',
    phoneIncorrectToast: 'يرجى التحقق من هاتفك',
    userExistToast: 'المستخدم موجود بالفعل',
    countryCodeRepeatToast: 'يرجى عدم إدخال رمز الدولة بشكل متكرر!',
    logoutDialog: 'هل أنت متأكد من تسجيل الخروج؟',
    pwdRequirement: 'يجب أن تتكون كلمة المرور من 8 إلى 16 حرفًا على الأقل مع أحرف وأرقام',
    signup: 'التسجيل',
    registerSuccessToast: 'التسجيل بنجاح',
    oldPwdErrorToast: 'يرجى التحقق من كلمة المرور القديمة'
  },
  checkUserInfo: {
    title: 'مركز الإدارة',
    emptyInfoNote: 'لا توجد معلومات عن الحساب الحالي، يرجى التحقق من حساب MetWallet الذي تحتاج إلى التحقق منه.',
    infoNote: 'إليك معلومات التحقق الخاصة بك.',
    lastSuccessWithdrawal: 'آخر عملية سحب ناجحة',
    copyBtn: 'نسخة',
    successToast: 'تم النسخ بنجاح!',
    failToast: 'فشل النسخ!'
  },
  country: {
    title: 'حدد المنطقة',
    popular: 'شائع'
  },
  documentDetails: {
    title: 'تفاصيل المستند',
    contract: 'العقد',
    goToSign: 'انتقل إلى التوقيع عليه',
    download: 'تنزيل',
    upload: 'تحميل',
    fileTypeLimit: 'doc., pdf., xlsx., xls., png., jpg., jpeg., المستندات فقط.',
    contentEmptyToast: 'يرجى إدخال المحتوى',
    placeOfBirth: 'مكان الميلاد',
    occupation: 'المهنة',
    fileForm: '(نموذج الملف)',
    proofOfAddress: 'إثبات العنوان باللغة الإنجليزية',
    residenceDoc: 'وثيقة الإقامة',
    textForm: '(نموذج نصي)',
    contractAgent: 'وكيل العقد',
    contractPayslip: 'شهادة راتب العقد',
    uncompletedToast: 'يرجى إكمالها للإرسال',
    successToast: 'تم الإرسال بنجاح',
    undefinedFileTypeToast: 'نوع تحميل ملف غير محدد',
    uploadFailToast: 'فشل التحميل'
  },
  filters: {
    amount: 'المبلغ',
    filter: 'المرشحات',
    time: 'الوقت',
    reset: 'إعادة التعيين',
    timePickerTitle: 'حدد {0} الوقت',
    start: 'البداية',
    end: 'النهاية',
    maximum: 'على الأكثر',
    minimum: 'على الأقل'
  },
  home: {
    balance: 'الرصيد',
    transactions: 'المعاملات',
    availableBalance: 'الرصيد المتاح',
    noWithdrawalMethodToast: 'هناك حاجة إلى طريقة سحب واحدة على الأقل.',
    linkAccount: 'ربط الحساب',
    all: 'جميع',
    cashIn: 'المدفوعات النقدية',
    loading: 'جاري التحميل...',
    noMore: 'لا مزيد من المعاملات',
    reload: 'فشل التحميل، انقر لإعادة التحميل',
    receivedFrom: 'تم الاستلام من',
    transferredTo: 'تم التحويل إلى',
    fee: 'رسوم التحويل إلى',
    myEmail: 'بريدي الإلكتروني',
    myPhone: 'هاتفي',
    invalidBasicLevelDialog:
      'نظرًا لإدراج رموز أو مسافات أو أرقام في حقل اسمك، فإن السحب من الحساب غير ممكن. يرجى ملء المعلومات الأساسية مرة أخرى (تأكد من أن الاسم لا يتضمن رموزًا أو مسافات أو أرقامًا وإذا لم يكن لديك اسم عائلة أو اسم وسط، فما عليك سوى تركه فارغًا.)',
    lackLastNameDialog: 'لم يتم ملء اسمك الأخير، مما سيعيق عملية السحب.',
    fillIn: 'املأ',
    viewDetails: 'عرض التفاصيل',
    docReviewingDialogTitle: 'يرجى الانتظار حتى يتم تمرير المستند.',
    docReviewingDialogContent:
      'لقد قدمت المستند، ولكن لا يمكنك استخدام MetWallet قبل تمرير مستندك.<br>سيقوم الموظفون الرسميون بمعالجته قريبًا، يرجى الانتظار لفترة.',
    docPassedDialog: 'تم تمرير المستند الذي قدمته. <br>يمكنك استخدام MetWallet بشكل طبيعي الآن.',
    docUnqualifiedDialog: 'المستند الذي قدمته غير مؤهل. <br>يرجى تقديم مستند مؤهل.',
    goToSubmit: 'انتقل لتقديمه',
    uncompletedDialog: 'يجب إكماله لاستخدام MetWallet بشكل طبيعي',
    useMetWalletNormallyAfterPassed: 'يمكنك استخدام MetWallet بشكل طبيعي بعد تمرير المستند.',
    requireSemiVerifiedDialog: '{0}، وفقًا لمتطلبات البنك، يجب عليك إكمال الجزء شبه الموثق في غضون 48 ساعة لسحب ناجح.',
    goToVerify: 'انتقل للتحقق',
    emailInvalidDialog:
      '{0}، عنوان بريدك الإلكتروني هو نفسه عنوان شخص آخر. للتأمين على الخصوصية، يرجى إدخال عنوان بريدك الإلكتروني الخاص في أقرب وقت ممكن.',
    later: 'لاحقًا',
    transferRequireSemiVerifiedDialog: 'يرجى إكمال التحقق شبه المعتمد قبل التحويل.',
    modifyBtnText: 'تعديل معلوماتي',
    unmodifiedTitle: 'غير قادر على التعديل',
    unmodifiedContent: 'لديك طلب سحب قيد المعالجة. لا يمكن تعديل المعلومات الآن.'
  },
  signing: {
    signature: 'التوقيع',
    date: 'التاريخ',
    employeeName: 'اسم الموظف',
    designation: 'التعيين',
    month: 'الشهر',
    year: 'السنة',
    earnings: 'الأرباح',
    deductions: 'الخصومات',
    basic: 'الأساسي وDA(بالدولار الأمريكي)',
    totalAddition: 'إجمالي الإضافة',
    totalDeduction: 'إجمالي الخصم',
    salary: 'الراتب الصافي',
    refNo: 'رقم المرجع',
    paymentTransferDate: 'تاريخ تحويل الدفع',
    nameOfBank: 'اسم البنك',
    signatureOfEmployee: 'توقيع الموظف',
    director: 'المدير',
    signNote: 'يرجى التوقيع باسمك',
    preview: 'معاينة',
    clear: 'مسح',
    save: 'حفظ',
    noSignatureToast: 'لا يمكنك الحفظ بدون توقيع.',
    fieldEmptyToast: 'يرجى ملء جميع المعلومات.'
  },
  transactionDetail: {
    title: 'تفاصيل المعاملة',
    status: 'الحالة',
    pending: 'معلق',
    completed: 'مكتمل',
    success: 'نجاح',
    failed: 'فشل',
    cancelled: 'تم إلغاؤه',
    onHold: 'معلق',
    reason: 'سبب الحالة',
    description: 'الوصف',
    creationDate: 'تاريخ الإنشاء',
    lastStatusDate: 'تاريخ الحالة الأخير',
    requestedAmount: 'المبلغ المطلوب',
    receiveAmount: 'استلام المبلغ',
    transferAmount: 'مبلغ التحويل',
    amountToPay: 'المبلغ المطلوب دفعه',
    transferFee: 'رسوم التحويل',
    processingFee: 'رسوم المعالجة',
    method: 'الطريقة',
    country: 'البلد',
    name: 'الاسم',
    bankPendingText: 'قيد المراجعة المصرفية النهائية',
    pendingText: 'قيد المراجعة {0}',
    chametSalary: 'راتب شاميت',
    userSalary: 'راتب المستخدم',
    comm: 'إتصالات.',
    gemgalaSalary: 'راتب جيمغالا'
  },
  transfer: {
    title: 'إلى حساب MetWallet',
    noPayPwdDialog: 'يرجى تعيين كلمة مرور دفع مكونة من 6 أرقام قبل التحويل.',
    records: 'السجلات',
    cashInOut: 'إيداع نقدي {0}، سحب نقدي {1}',
    transfer: 'تحويل',
    fee: 'رسوم',
    remark: 'ملاحظة',
    transferTo: 'التحويل إلى {0}',
    remarkPlaceholder: 'إضافة ملاحظة حول التحويل (أقل من 100 حرف)',
    firstNameNote: 'الرجاء إدخال الاسم الأول',
    sendingAmount: 'المبلغ المرسل',
    receivingAmount: 'المبلغ المستلم',
    transferNow: 'التحويل الآن',
    noBalanceToast: 'مبلغ التحويل أكبر من مبلغ الرصيد.',
    amountTooLittleToast: 'لا يمكن أن يكون مبلغ التحويل أقل من 10 دولارات.'
  },
  bankData: {
    beneficiaryName: 'اسم المستفيد',
    beneficiaryNamePlaceholder: 'أدخل الاسم',
    beneficiaryLastname: 'اسم عائلة المستفيد',
    beneficiaryLastnamePlaceholder: 'أدخل الاسم الأخير',
    bankCode: 'رمز البنك',
    bankCodePlaceholder: 'حدد رمز البنك',
    bankIFSCCode: 'رمز IFSC للبنك',
    bankIFSCCodePlaceholder: 'أدخل IFSC للبنك',
    bankAccount: 'حساب البنك',
    bankAccountPlaceholder: 'أدخل حساب البنك',
    email: 'البريد الإلكتروني',
    emailPlaceholder: 'أدخل البريد الإلكتروني',
    phoneNumber: 'رقم الهاتف',
    phoneNumberPlaceholder: 'أدخل رقم الهاتف',
    address: 'العنوان',
    addressPlaceholder: 'أدخل العنوان',
    city: 'المدينة',
    cityPlaceholder: 'أدخل المدينة',
    state: 'الولاية',
    statePlaceholder: 'أدخل الولاية',
    postCode: 'الرمز البريدي',
    postCodePlaceholder: 'أدخل الرمز البريدي',
    documentId: 'معرف المستند',
    documentIdPlaceholder: 'أدخل معرف المستند',
    nationalId: 'National ID',
    nationalIdPlaceholder: 'Enter National ID',
    individualTaxId: 'Individual Tax ID',
    individualTaxIdPlaceholder: 'Enter Individual Tax ID',
    documentType: 'نوع المستند',
    documentTypePlaceholder: 'حدد نوع المستند',
    accountType: 'نوع الحساب',
    accountTypePlaceholder: 'حدد نوع الحساب',
    cpfcnpjPlaceholder: 'أدخل CPFCNPJ',
    bankBranch: 'فرع البنك',
    bankBranchPlaceholder: 'أدخل فرع البنك',
    ribOfBankAccount: 'RIB لحساب البنك',
    bankName: 'اسم البنك',
    bankNamePlaceholder: 'أدخل اسم البنك',
    bicCode: 'رمز BIC',
    bicCodePlaceholder: 'أدخل رمز BIC',
    ibanPlaceholder: 'أدخل IBAN',
    bankSwift: 'سويفت البنك',
    bankSwiftPlaceholder: 'أدخل سويفت البنك',
    name: 'الاسم',
    documentCountry: 'دولة المستند',
    documentCountryPlaceholder: 'حدد دولة المستند',
    issueDate: 'تاريخ إصدار المستند',
    issueDatePlaceholder: 'حدد تاريخ الإصدار',
    expireDate: 'تاريخ انتهاء صلاحية المستند',
    expireDatePlaceholder: 'حدد تاريخ انتهاء الصلاحية',
    bankBranchName: 'اسم فرع البنك',
    bankBranchNamePlaceholder: 'أدخل اسم الفرع',
    branchPlaceholder: 'أدخل الفرع',
    gender: 'الجنس',
    genderPlaceholder: 'حدد الجنس',
    birthday: 'عيد الميلاد',
    birthdayPlaceholder: 'اختر عيد الميلاد',
    phone: 'الهاتف',
    bankAddress: 'عنوان البنك',
    bankAddressPlaceholder: 'أدخل عنوان البنك',
    bankAccountName: 'اسم الحساب المصرفي',
    bankAccountNamePlaceholder: 'أدخل اسم الحساب المصرفي',
    province: 'المحافظة',
    provincePlaceholder: 'أدخل المحافظة',
    postalCode: 'الرمز البريدي',
    postalCodePlaceholder: 'أدخل الرمز البريدي',
    savingsAccount: 'حساب التوفير',
    abaRoutingNumber: 'رقم توجيه ABA',
    englandBankAccount: 'حساب مصرفي في إنجلترا',
    bankBranch2: 'فرع البنك',
    bankBranch2Placeholder: 'فقط إذا كان البنك هو سانتاندير',
    paternalName: 'اسم الأب',
    paternalNamePlaceholder: 'أدخل اسم الأب',
    passportIdNumber: 'رقم هوية جواز السفر',
    bankNamePlaceholder2: 'اختر اسم البنك',
    areaCode: 'رمز المنطقة',
    phoneNumberNoAreaCode: 'رقم الهاتف (بدون رمز المنطقة)',
    idType: 'نوع الهوية',
    idNo: 'رقم الهوية',
    idIssueDate: 'تاريخ إصدار الهوية',
    idExpireDate: 'تاريخ انتهاء صلاحية الهوية',
    ibanStyleToast: "يُرجى إدخال محتوى يبدأ بـ 'SA' بطول 24 حرفًا."
  },
  rechargeAndTransfer: {
    transfer_limit_1: 'لا يمكنك التحويل إلا إلى بائعي الماس',
    search: 'بحث',
    history: 'المستخدمون المحولون',
    confirm_content: 'هل أنت متأكد من تحويل {0} إلى {1}',
    success_content: 'تم تحويل {0} إلى {1}',
    purchase: 'شراء',
    purchase_success: 'لقد قمت بشراء {0} بنجاح',
    insufficient_balance: 'رصيد غير كافٍ',
    purchase_diamond: 'شراء الماس',
    transfer_limit_2: 'يجب أن يكون مبلغ التحويل بين 10 دولارات و30000 دولار',
    no_data: 'لا توجد بيانات',
    invalid_number: 'يرجى إدخال رقم صالح',
    under_limit: 'يجب ألا يقل مبلغ التحويل عن 10 دولارات',
    over_limit: 'يجب أن يكون مبلغ التحويل أقل من 30000 دولار'
  },
  redesign: {
    emailPlaceholder: 'أدخل عنوان البريد الإلكتروني',
    retrievePwd: 'استرداد كلمة المرور',
    resetPwd: 'إعادة تعيين كلمة المرور',
    newPwdPlaceholder: 'أدخل كلمة مرور جديدة',
    reenterNewPwdPlaceholder: 'أعد إدخال كلمة مرور جديدة',
    reenterPayPwdPlaceholder: 'يرجى إعادة إدخال كلمة مرور الدفع',
    sendToPhone: 'تم إرسال رمز التحقق إلى هاتفك',
    sendToWhatsapp: 'تم إرسال رمز التحقق إلى WhatsApp الخاص بك',
    sendToEmail: 'تم إرسال رمز التحقق إلى بريدك الإلكتروني',
    invalidCode: 'رمز غير صالح',
    userId: 'معرف المستخدم',
    other: 'آخر',
    transactionRecord: 'سجل المعاملات',
    bankCardInfo: 'حساب بطاقة مصرفية',
    withdrawInfo: 'حساب السحب',
    toFillIn: 'يجب ملؤها',
    walletInfo: 'معلومات حساب المحفظة',
    toComplete: 'يجب استكمالها',
    verifyGuide: 'أكمل معلومات حساب المحفظة للحصول على مؤهلات سحب أكثر',
    verifyNote: 'أكمل المعلومات التالية للحصول على مؤهلات سحب يومية بقيمة {0}',
    verifyCompletedNote: 'تم استكمال المعلومات للحصول على مؤهلات سحب يومية بقيمة {0}',
    continueBtnText: 'متابعة التعبئة',
    submitInfo: 'إرسال المعلومات',
    transferAmount: 'مبلغ التحويل',
    newEmailVerify: 'التحقق من البريد الإلكتروني الجديد',
    verifyCodePlaceholder: 'أدخل رمز التحقق',
    emailIncorrectToast: 'يرجى إدخال عنوان بريد إلكتروني صحيح',
    newPhone: 'رقم هاتف جديد',
    accountAdded: 'تمت إضافة معلومات الحساب',
    accountToAdd: 'يمكن إضافة حسابات أخرى',
    edit: 'تعديل',
    enterPayPwd: 'أدخل كلمة مرور الدفع',
    deleteBtnText: 'حذف',
    transferTo: 'التحويل إلى',
    withdrawable: 'قابل للسحب',
    goSet: 'اذهب إلى المجموعة',
    goModify: 'اذهب إلى التعديل'
  }
}



// WEBPACK FOOTER //
// ./src/configs/language/lang/ar.js